import VeeValidate, { Validator } from 'vee-validate'
import PhoneNumber from 'awesome-phonenumber'
import Vue from 'vue'

// Komunikat tej reguly siedzi w slownikach vee-validate w setup/i18n.js,
// dzieki czemu przelacza sie razem z jezykiem UI.
Validator.extend('phone', {
  validate(value) {
    return new Promise(resolve => {
      const phone = new PhoneNumber(value)
      resolve({ valid: phone.isValid() })
    })
  }
})

Vue.use(VeeValidate)
